const ITEMS = [
  "REAL-TIME TRAFFIC INTELLIGENCE",
  "LIVE TSA WAIT TIMES",
  "SMART LEAVE-TIME ALERTS",
  "PREDICTIVE FLIGHT DELAYS",
  "DOOR-TO-GATE ORCHESTRATION",
  "WEATHER RADAR INSIGHTS",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#101315] py-5 select-none"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-lg sm:text-xl font-bold tracking-wide text-slate-200 px-6">
                  {item}
                </span>
                <span className="text-primary text-xl">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
